export enum RecommendationInteractionEnum {
    Accepted = 'accepted',
    ListAdded = 'listAdded',
    Later = 'later',
    Never = 'never'
}
